export default function buildCampaignPopupTarget({
  route = {},
  popup = '',
  arenaId = '',
  slug = '',
} = {}) {
  const nextQuery = {
    ...(route.query || {}),
  }

  delete nextQuery.popup
  delete nextQuery.arena_id
  delete nextQuery.slug

  if (arenaId) {
    nextQuery.arena_id = arenaId
  }

  if (slug) {
    nextQuery.slug = slug
  }

  if (popup) {
    nextQuery.popup = popup
  }

  return {
    name: route.name,
    params: {
      ...(route.params || {}),
    },
    query: nextQuery,
  }
}
